import { render } from "./GoToMap.vue?vue&type=template&id=828cdfb2&ts=true"
import script from "./GoToMap.vue?vue&type=script&lang=ts"
export * from "./GoToMap.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__